<span (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()" *ngIf="!emptyValue">
  <span (click)="copyValue()" *ngIf="displayL && iconVisible"
    ><fa-icon icon="copy" size="sm" title="Copy External Id"></fa-icon
  ></span>
  <span class="m-l-3" *ngIf="displayL && !completed && iconVisible && isLongValue()" (click)="showValue()"
    ><fa-icon icon="eye" size="sm" [title]="externalId"></fa-icon
  ></span>
  <span class="m-l-5" *ngIf="!completed" (click)="showValue()">{{ externalId | externalIdentifier }}</span>
  <span class="m-l-5" *ngIf="completed" (click)="showValue()">{{ externalId }}</span>
  <span class="m-l-5" *ngIf="displayR && !completed && iconVisible && isLongValue()" (click)="showValue()"
    ><fa-icon icon="eye" size="sm" [title]="externalId"></fa-icon
  ></span>
  <span class="m-l-3" (click)="copyValue()" *ngIf="displayR && iconVisible"
    ><fa-icon icon="copy" size="sm" title="Copy External Id"></fa-icon
  ></span>
</span>
